module.exports = __webpack_public_path__ + "static/media/tickIcon.afba84de.svg";